module.exports = __webpack_public_path__ + "img/nuage.6ffc3e32.png";